import React, { Component } from 'react';

export default class Header extends Component {
    render() {
        return (
            <div>
                404 Page Not found
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/nomatch/index.js